import { ISeanceReport } from 'src/types/seanceReport';

export const groupSeanceReportToTotal = (data: ISeanceReport[]) => {
    let groupData: any = {};
    const total1 = 0;
    const total2 = 0;
    const total3 = 0;
    const total4 = 0;
    const total5 = 0;
    const total6 = 0;
    const total7 = 0;
    const total8 = 0;
    let total9 = 0;
    data.forEach((it) => {
        total9 += it.confirmedHours ? Number(it.confirmedHours) : 0;
    });
    groupData = {
        id: ``,
        caseNumber: true,
        caseType: total1,
        studentId: total2,
        providerId: total3,
        supervisorId: total8,
        orderId: total4,
        orderName: total5,
        serviceTypeTitle: total6,
        serviceLocationTitle: total7,
        confirmedHours: total9,
    };

    return groupData;
};
